import { Outlet } from 'react-router-dom';
import { Sidebar, BottomTabBar } from '@/components/Sidebar';
import { TopBar } from '@/components/TopBar';
import { ErrorBoundary } from '@/components/ErrorBoundary';

/**
 * Layout — top-level shell for authenticated routes. Sidebar on the left
 * (desktop only), top bar across the main column, an Outlet for the
 * active route, and a bottom tab bar on mobile.
 *
 * `aria-live="polite"` region is placed here so agent status changes can
 * announce themselves globally (§8.9).
 */
export function Layout() {
  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />

        <main
          id="main-content"
          className="flex-1 pb-16 md:pb-0"
          role="main"
        >
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>

      <div
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        id="global-aria-live"
      />

      <BottomTabBar />
    </div>
  );
}

export default Layout;
